import React, { ReactNode } from 'react';
import * as Styled from './styled';

interface ConfigSliderProps {
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
  step: number;
  label: string;
  children?: ReactNode;
}

const ConfigSlider: React.FC<ConfigSliderProps> = ({ value, onChange, min, max, step, label }) => {
  const handleValueChange = (newValues: number[]) => {
    onChange(newValues[0]);
  };

  return (
    <Styled.Container>
      <Styled.Root value={[value]} onValueChange={handleValueChange} min={min} max={max} step={step} aria-label={label}>
        <Styled.Track>
          <Styled.Range />
        </Styled.Track>
        <Styled.Thumb />
      </Styled.Root>
    </Styled.Container>
  );
};

export default ConfigSlider;
